export const getPageQueryParams = (currentPageNumber = 1, pagePerItemCount = 10, sortOption = '') => {
  return {
    page: currentPageNumber - 1,
    size: pagePerItemCount,
    sort: sortOption,
  };
};
